/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default async () => {
  const PickUpStoreModalSaga = await Promise.resolve(
    import(/* webpackChunkName: "pickup-store-modal-saga" */ './PickUpStoreModal.saga')
  );

  useInjectReducerAndSaga(null, {
    key: 'PickUpStoreModalSaga',
    saga: PickUpStoreModalSaga.default,
  });
  return null;
};
